<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :checkboxConfig="{
        highlight: false,
      }"
      :expand-config="{ reserve: true }"
      class="order-goods-tbale"
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <GoodsSpec :disabled="disabled" :param="row" class="m-2" />
      </template>
      <template v-slot:displayName="{ row }">
        <span>
          {{ row.orderGoodsName }} {{ row.orderGoodsPattern }}
          {{ row.orderGoodsEnglishSize }}
          {{ row.orderGoodsColor }}
        </span>
      </template>
      <template v-slot:isGroup="{ row }">
        <el-tag size="mini" :type="row.isGroup === 'Y' ? 'light' : 'info'">
          {{ row.v_isGroup }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openDetailDialog', {
                  type: 'detail',
                  code: row.changeOrderGoodsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openDetailDialog', {
                  type: 'edit',
                  code: row.changeOrderGoodsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.changeOrderGoodsCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="
                $emit('openAddDialog', {
                  type: 'copy',
                  param: row,
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import GoodsSpec from '../goods-spec/table'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  components: { GoodsSpec },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      var qty = 0
      var boxQty = 0
      var subAmount = 0
      var saleSubAmount = 0
      var subNetSalePrice = 0
      this.tableData.forEach((data) => {
        qty = add(parseInt(data.qty), qty)
        boxQty = add(parseFloat(data.boxQty), boxQty)
        subAmount = add(parseFloat(data.subAmount), subAmount)
        saleSubAmount = add(parseFloat(data.saleSubAmount), saleSubAmount)
        subNetSalePrice = add(parseFloat(data.subNetSalePrice), subNetSalePrice)
      })
      return [
        [
          '合计',
          '',
          '',
          '',
          '',
          '',
          qty.toFixed(0),
          '',
          '',
          boxQty,
          '',
          subAmount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
          '',
          saleSubAmount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
          '',
          subNetSalePrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
        ],
      ]
    },
  },
  methods: {
    footerMethod() {
      // 返回一个二维数组的表尾合计
      return this.footerData
    },
    del(changeOrderGoodsCode) {
      this.$emit('batchDel', [changeOrderGoodsCode])
    },
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning',
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.changeOrderGoodsCode
        })
      }
      return data
    },
    onMousedown() {
      this.$refs.vxeGrid.clearRowExpand()
    },
  },
}
</script>
